import { useRef } from 'react';

import { isNil as _isNil } from 'lodash';

import AnimationManager from './AnimationManager';

function getAnimationManagerInstance(config) {
  return new AnimationManager(config);
}

function useAnimationManager(config = {}) {
  const { animationManager, ..._config } = config || {};
  const animationManagerInstance = useRef(animationManager);

  if (_isNil(animationManagerInstance.current)) {
    animationManagerInstance.current = getAnimationManagerInstance(_config);
  }

  return animationManagerInstance;
}

function useModalAnimation(isVisible, options, config = {}) {
  const animationManagerInstance = useAnimationManager(config);

  return animationManagerInstance.current.getModalAnimations(isVisible, options);
}

function useSubTrayAnimation(isVisible, trayAction, config = {}) {
  const animationManagerInstance = useAnimationManager(config);

  return animationManagerInstance.current.getSubTrayAnimations(isVisible, trayAction);
}

function useTabsAnimation(activeIndex, options, config = {}) {
  const animationManagerInstance = useAnimationManager(config);

  return animationManagerInstance.current.getTabAnimations(activeIndex, options);
}

function useTrayAnimation(upTray, dropTray, config = {}) {
  const animationManagerInstance = useAnimationManager(config);

  return animationManagerInstance.current.getTrayAnimations(upTray, dropTray);
}

export {
  getAnimationManagerInstance,
  useAnimationManager,
  useModalAnimation,
  useSubTrayAnimation,
  useTabsAnimation,
  useTrayAnimation,
};
